'use strict';

exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/history/lib/ExecutionEnvironment.js
// module id = 142
// module chunks = 0